





















































import { Component } from 'vue-property-decorator';

import { Gradient } from '@/components/wobble/model';
import Chapter from './Chapter.vue';
import FloatingWobble from '@/components/wobble/FloatingWobble.vue';

@Component({
  components: {
    FloatingWobble,
  }
})
export default class Outro extends Chapter {
  public wobbleGradient = new Gradient(
    '#A67BEB',
    '#21D1DC',
    0.5,
    0.8,
    420.97,
    -235.8,
    147.67,
    535.89,
  );
}
